export const Colors = {
	Black: '§0',
	DarkBlue: '§1',
	DarkGreen: '§2',
	DarkAqua: '§3',
	DarkRed: '§4',
	DarkPurple: '§5',
	Gold: '§6',
	Gray: '§7',
	DarkGray: '§8',
	Blue: '§9',
	Green: '§a',
	Aqua: '§b',
	Red: '§c',
	LightPurple: '§d',
	Yellow: '§e',
	White: '§f',
} as const;

export const Formats = {
	Obfuscated: '§k',
	Bold: '§l',
	Strikethrough: '§m',
	Underline: '§n',
	Italic: '§o',
	Reset: '§r',
} as const;
